import { ReactNode } from 'react';

export const OUTLINE_TAG_SIZE_S = 's';
export const OUTLINE_TAG_SIZE_XS = 'xs';

export type OutlineTagSize = typeof OUTLINE_TAG_SIZE_S | typeof OUTLINE_TAG_SIZE_XS;

export const OUTLINE_TAG_VARIANT_PRIMARY = 'primary';
export const OUTLINE_TAG_VARIANT_WARNING = 'warning';

export type OutlineTagVariant = typeof OUTLINE_TAG_VARIANT_PRIMARY | typeof OUTLINE_TAG_VARIANT_WARNING;

export interface OutlineTagProps {
  children: ReactNode;
  size?: OutlineTagSize;
  variant?: OutlineTagVariant;
  className?: string;
  dataTestId?: string;
}
